<div class="rubric"><slot /></div>
